import { getAgentNameFilter } from './agentName/agentName';
import { getConfidenceFilter } from './confidence/confidence';
import { getNationalityFilter } from './nationality/nationality';
import { getCountryOfResidenceFilter } from './countryOfResidence/countryOfResidence';
import { FilterGroup } from 'api-paths-cas';
import { getMarketFilter } from './market/market';
import { getRiskRegionFilter } from './riskRegion/riskRegion';
import { getApplicationCountryFilter } from './applicationCountry/applicationCountry';
import { getEvidenceRequirementsFilter } from './evidenceRequirements/evidenceRequirements';
import { notEmpty } from '@/utilities/helpers';
import { IGetFilterGroupsProps } from '../types';

export const getStudentOption = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'STUDENTS',
    filters: [
      getAgentNameFilter(props),
      getNationalityFilter(props),
      getCountryOfResidenceFilter(props),
      getApplicationCountryFilter(props),
      getMarketFilter(props),
      getRiskRegionFilter(props),
      getEvidenceRequirementsFilter(props),
      getConfidenceFilter(props),
    ].filter(notEmpty),
  };
};
